import type { FaireProductEntity } from "../../entity_types/product";

export const p_tyvyv6psh6: FaireProductEntity = {
  token: "p_tyvyv6psh6",
  type: "product",
  name: "Checkered Bohemian Tassel Camisole",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/91d393325160f0a3d04299b6871742afb51dd7e58c9127653dc4704d7130cbf1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3f982c923cd15aec3c61f845d4c568df880615e2003b3e3ed52a83ac602cb94.jpeg",
    "https://cdn.faire.com/fastly/504c9d6f0d88442d5c86c204da93b69914d11ffe53657a560b1aefa6988e39dd.jpeg",
    "https://cdn.faire.com/fastly/2d4908c51835e18eff7a083c4177303b02e97a97192b83a0d74157ed32810853.jpeg",
    "https://cdn.faire.com/fastly/dba23c680873d8dde077aa1c8d7caf36c6fb2050875d5e074afafec76917ee63.jpeg",
    "https://cdn.faire.com/fastly/f0ae527dce83c96a6dcdfacaa76d88610824a2f1390625c80170231cbce10d3b.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "Boho-Chic Appeal: This checkered camisole embodies the bohemian spirit with its playful tassels, making it a perfect choice for your travel wardrobe or any casual, free-spirited occasion.\n One Size Fits Most: With a garment length of 43 cm and a bust circumference of 86 cm, this top is designed to fit a range of sizes comfortably, ensuring a relaxed and flattering look.\n Travel-Ready Style: Lightweight and stylish, this tassel-adorned camisole is ideal for travel, offering a versatile piece that pairs well with shorts, skirts, or jeans, making it a must-have for your next adventure or summer outing.",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:47.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
